import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import EachPurchaseEntity from '../../CompanyRoutes/PurchaseHistory/EachPurchase.component';
import FilterIcon from '../../Visuals/Icons/FilterIcon.icon';

const UserPurchasesInner = ({ purchaseHistory }) => {
  const [search, setSearch] = useState('');
  const [sortOrder, setSortOrder] = useState('desc'); // 'asc' or 'desc'

  // Filter and sort purchases
  const filteredPurchases = useMemo(() => {
    let filtered = Array.isArray(purchaseHistory) ? purchaseHistory : [];
    if (search?.trim()) {
      const lower = search.toLowerCase();
      filtered = filtered.filter((p) => {
        // Check single courseName
        const singleMatch =
          p?.courseName && p?.courseName.toLowerCase()?.includes(lower);

        // Check array of courses
        const arrayMatch =
          Array.isArray(p?.courses) &&
          p?.courses.some(
            (c) => c?.courseName && c?.courseName.toLowerCase().includes(lower)
          );

        // Check transactionId and purchaser as before
        const transactionMatch =
          p?.transactionId && p?.transactionId?.toLowerCase().includes(lower);
        const purchaserMatch =
          p?.purchaser && p?.purchaser.toLowerCase().includes(lower);

        return singleMatch || arrayMatch || transactionMatch || purchaserMatch;
      });
    }
    filtered = [...filtered].sort((a, b) => {
      const dateA = new Date(a?.transactionDate || a?.purchaseDate || 0);
      const dateB = new Date(b?.transactionDate || b?.purchaseDate || 0);
      return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });
    return filtered;
  }, [purchaseHistory, search, sortOrder]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          marginBottom: '1rem',
        }}
      >
        <input
          type="text"
          placeholder="Search by course or transaction ID"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            padding: '0.4rem',
            borderRadius: '4px',
            width: '20%',
            border: '1px solid #ccc',
          }}
        />

        <FilterIcon
          functionName={() =>
            setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'))
          }
        />
      </div>
      {filteredPurchases?.length > 0 ? (
        filteredPurchases?.map((purchase, i) => (
          <EachPurchaseEntity
            purchase={purchase}
            key={purchase?.transactionId || i}
          />
        ))
      ) : (
        <p>No purchase history available.</p>
      )}
    </>
  );
};

UserPurchasesInner.propTypes = {
  purchaseHistory: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      userId: PropTypes.string,
      productId: PropTypes.string,
      purchaseDate: PropTypes.string,
      transactionDate: PropTypes.string,
      amount: PropTypes.number,
      courseName: PropTypes.string,
      transactionId: PropTypes.string,
      purchaser: PropTypes.string,
    })
  ),
};

export default UserPurchasesInner;
